/**
 * Asynchronously loads the component for Pdf viewer page
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
